// Update this date when the terms content changes — triggers re-acceptance for all users.
export const TERMS_OF_SERVICE_ISSUED_DATE = "2026-05-05";

export const TERMS_OF_SERVICE_MD = `---
title: Terms of Service
issuedDate: "${TERMS_OF_SERVICE_ISSUED_DATE}"
---

# Terms of Service

**Effective Date: May 1, 2026**

By accessing or using the Erode platform, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our application.

## 1. Acceptance of Terms

By accessing or using the Erode application, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our application.

## 2. Use of Services

You agree to use the Erode application only for lawful purposes and in accordance with these Terms. You agree not to use the application:

- In any way that violates any applicable federal, state, local, or international law or regulation
- To transmit, or procure the sending of, any advertising or promotional material
- To impersonate or attempt to impersonate Erode, an Erode employee, another user, or any other person or entity

## 3. Data Privacy

We respect your privacy and are committed to protecting your personal data. Our Privacy Policy describes how we collect, use, and share information about you when you use our services. By using Erode, you consent to our data practices as described in our Privacy Policy.

## 4. Intellectual Property

The Erode application and its entire contents, features, and functionality are owned by Erode, its licensors, or other providers and are protected by United States and international copyright, trademark, patent, and other intellectual property or proprietary rights laws.

## 5. Limitation of Liability

In no event shall Erode, its affiliates, or their licensors, service providers, employees, agents, officers, or directors be liable for damages of any kind arising out of or in connection with your use, or inability to use, the application, including but not limited to direct, indirect, incidental, consequential, or punitive damages.
`;
